const t = {
  content: "",
  group: "block",
  marks: "",
  atom: !0,
  attrs: {
    type: { default: "ifElseStatement" },
    fallbackBlocks: {},
    predicatesBlocksPairs: {}
  },
  toDOM() {
    return ["div"];
  }
};
export {
  t as ifElseStatementSpec
};
